import React, { useState } from 'react';
import OnClickOutside from 'sushiweb/HOC/OnClickOutside';
import './AgentActions.scss';
import { useQueryCall } from '../../../api/react-client';
import { agentActionsModel } from '../../../api';
import Shimmer from 'sushiweb/Shimmer';

const ASSUMED_KEBAB_ITEMS_COUNT = 9;

const KebabItemsMenu = ({
  isMenuVisible,
  closeActionsMenu,
  onSelectMenuItem,
  orderId,
  userId,
}) => {
  const [menuList, setMenuList] = useState([]);

  // fetch kebab items
  const { isLoading: isDataLoading } = useQueryCall(
    { enabled: isMenuVisible },
    null,
    ['KebabItemsMenu'],
    () => {
      if (orderId && userId) {
        agentActionsModel
          .getKebabItems({
            params: { order_id: orderId || '', user_id: userId },
          })
          .then((res) => {
            if (res?.isError) {
              return;
            }
            const filtered = res?.filter(
              (item) => item.slug !== 'get_wallet_transactions',
            );
            setMenuList(filtered);
          });
      }
    },
  );

  const handleClickOutside = () => {
    closeActionsMenu();
  };

  if (!isMenuVisible) return null;

  return (
    <div className='tw-absolute tw-right-0 tw-top-[3.5rem] tw-bg-white tw-z-10 tw-shadow-sm tw-rounded-xl tw-overflow-hidden tw-border tw-border-solid tw-border-grey-200'>
      <OnClickOutside handleClickOutside={handleClickOutside}>
        {menuList?.length === 0 && (
          <div className='tw-grid tw-grid-cols-3 tw-grid-rows-3 tw-gap-1 tw-w-[70rem] tw-h-[17.5rem]'>
            {Array.from({ length: ASSUMED_KEBAB_ITEMS_COUNT }).map(
              (_, index) => (
                <div
                  className='tw-w-full tw-h-full'
                  key={index}
                  style={{ height: '100%' }}
                >
                  <Shimmer height='100%' width='100%' />
                </div>
              ),
            )}
          </div>
        )}
        {!isDataLoading && (
          <div className='tw-grid tw-grid-cols-3'>
            {menuList?.map((item, index) => {
              if (!item?.title) return null;
              return (
                <MenuItem
                  item={item}
                  onSelectMenuItem={onSelectMenuItem}
                  key={`${item.title}-${index}`}
                />
              );
            })}
          </div>
        )}
      </OnClickOutside>
    </div>
  );
};

export default KebabItemsMenu;

const MenuItem = ({ key, item, onSelectMenuItem }) => {
  return (
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    <div
      key={key}
      onClick={() => {
        if (!item.disabled) {
          onSelectMenuItem(item);
        }
      }}
      className={`tw-text-[1.4rem] tw-max-w-md tw-font-medium tw-text-zinc-600 tw-leading-none tw-p-6 tw-transition-all tw-ease-in-out tw-duration-300 ${
        item.disabled
          ? '!tw-text-zinc-400 tw-cursor-not-allowed'
          : 'hover:tw-bg-grey-100 hover:tw-scale-[102%] hover:tw-text-base-green '
      }`}
    >
      {item.title}
    </div>
  );
};
